import { render, staticRenderFns } from "./tab-range.vue?vue&type=template&id=32894947&scoped=true"
import script from "./tab-range.vue?vue&type=script&lang=js"
export * from "./tab-range.vue?vue&type=script&lang=js"
import style0 from "./tab-range.vue?vue&type=style&index=0&id=32894947&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32894947",
  null
  
)

export default component.exports